import React, { useMemo } from 'react';
import { Col } from 'reactstrap';
import ReactTableBase from './ReactTableBase'; // імпортуйте ваш ReactTableBase компонент

const mapSingleColumn = (key, col) => {
  const { Component, valueFunc } = col;
  return {
    id: key,
    Header: col.title || ' ',
    accessor: d => col.sort ? col.sort(d) : d[key],
    Cell: ({ value, row }) => {
      const deal = row.original;
      if (Component) {

        return (<Component record={deal} fieldId={key} />);
      }
      return typeof valueFunc === 'function' ? valueFunc(deal) || ' ' : value || ' ';
    },
    sortType: col.sort ? 'basic' : undefined,
    ...col,
  };
};

const mapColumns = (columns) => Object.keys(columns).map(key => mapSingleColumn(key, columns[key]));

const mapGroupedColumns = (groups) => groups.map((group, idx) => ({
  id: `group-${idx}`,
  Header: group.title || '',
  Footer: () => null,
  className: group.headerClassName || '',
  columns: Object.keys(group.columns).map(key => mapSingleColumn(key, group.columns[key])),
}));

const MatTableToTable = ({ dataArray, columns, columnGroups, defaultOrder, hideToolbar, key, filters }) => {
  const flatColumns = columnGroups
    ? columnGroups.reduce((acc, group) => ({ ...acc, ...group.columns }), {})
    : columns;

  const getItemsForTable = () => {
    // console.log(columns, 'COLUMNS');
    if(!dataArray) return [];
    return dataArray
      .filter((item) => {
        let isGood = true;
        Object.keys(filters || {}).forEach((filterKey) => {
          if (flatColumns[filterKey]?.filter && Array.isArray(flatColumns[filterKey].filter(item))) {
            const itemArray = flatColumns[filterKey].filter(item);
            let countFalse = 0;
            itemArray.forEach((d) => {
              if (!filters[filterKey][d]) {
                countFalse += 1;
              }
            });
            if (countFalse === itemArray.length) {
              isGood = false;
            }
          } else if (flatColumns[filterKey]?.filter && !filters[filterKey][flatColumns[filterKey].filter(item)]) {
            isGood = false;
          }
        });
        if (filters?.search && isGood && flatColumns[filters.search.column] && flatColumns[filters.search.column].searchFunc) {
          isGood = flatColumns[filters.search.column].searchFunc(item, filters.search.value);
        }
        return isGood;
      });
  };

  const data = useMemo(() => {
    return getItemsForTable({ });
  }, [filters, dataArray])
  console.log(data,dataArray,filters, 'data')

  const columnTransform = useMemo(
    () => (columnGroups ? mapGroupedColumns(columnGroups) : mapColumns(columns)),
    [columns, columnGroups],
  );

  const tableConfig = {
    isEditable: false,
    isResizable: false,
    isSortable: true,
    withPagination: true,
    manualPageSize: [10, 20, 30, 40],
    withSearchEngine: !hideToolbar,
    sortBy: defaultOrder?.orderBy || '_id',
    direction: defaultOrder?.order || 'desc',
    useFlex: true,
  };
  return (
    <Col className="mt-3">
      <ReactTableBase
        key={key || 'someDefaultFate'}
        columns={columnTransform}
        data={data}
        tableConfig={tableConfig}
      />
    </Col>

  );
};

export default MatTableToTable;
